"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountSavedBlockDropzone = exports.DropzonePosition = void 0;
var react_1 = __importStar(require("react"));
var SavedBlockDropzone_1 = require("./SavedBlockDropzone");
var mobx_react_1 = require("mobx-react");
var DropzonesStore_1 = require("./DropzonesStore");
var observe_rect_1 = __importDefault(require("@reach/observe-rect"));
var mobx_1 = require("mobx");
var DragStore_1 = require("Project/Stores/DragStore/DragStore");
var DropzonePosition;
(function (DropzonePosition) {
    DropzonePosition["Top"] = "top";
    DropzonePosition["Bottom"] = "bottom";
})(DropzonePosition = exports.DropzonePosition || (exports.DropzonePosition = {}));
var isElementInViewport = function (rect, percentVisible) {
    if (percentVisible === void 0) { percentVisible = 100; }
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    return !(Math.floor(100 - ((rect.top >= 0 ? 0 : rect.top) / +-(rect.height / 1)) * 100) < percentVisible ||
        Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) < percentVisible);
};
var SavedBlockDropzoneOuter = (function (_super) {
    __extends(SavedBlockDropzoneOuter, _super);
    function SavedBlockDropzoneOuter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.innerRef = (0, react_1.createRef)();
        _this.updateViewportStatus = function (rect) {
            var isInViewport = isElementInViewport(rect, 5);
            var isAbove = rect.top < window.innerHeight / 2;
            _this.props.dropzonesStore.setCurrentDropzoneViewportStatus(isInViewport, isAbove);
        };
        return _this;
    }
    SavedBlockDropzoneOuter.prototype.componentDidMount = function () {
        var _this = this;
        this.innerRectObserver = (0, observe_rect_1.default)(this.innerRef.current, function (rect) {
            _this.updateViewportStatus(rect);
        });
        this.scrollOnPersistentDropzoneOpenAutorunnerDisposer = (0, mobx_1.autorun)(function () {
            var _a = _this.props, blockList = _a.blockList, blockStore = _a.blockStore, position = _a.position, dropzonesStore = _a.dropzonesStore, projectScrollTo = _a.projectScrollTo;
            var blockIndex = blockList.getIndex(blockStore);
            var dropzoneIndex = blockIndex + (position === DropzonePosition.Top ? 0 : 1);
            var shouldScrollCurrentDropzone = dropzoneIndex === dropzonesStore.scrollToDropzoneIndex && dropzonesStore.isPersistent;
            if (shouldScrollCurrentDropzone) {
                dropzonesStore.clearScrollToDropzoneIndex();
                setTimeout(function () {
                    var rect = _this.innerRef.current.getBoundingClientRect();
                    if (rect.top < 0) {
                        projectScrollTo(_this.innerRef.current, {
                            offset: 50,
                            time: 500,
                            scrollingElement: ".content-container__scroll-container",
                        });
                    }
                }, 400);
            }
        });
        this.activeAutorunnerDisposer = (0, mobx_1.autorun)(function () {
            if (_this.isActive) {
                _this.innerRectObserver.observe();
            }
            else {
                _this.innerRectObserver.unobserve();
            }
        });
        this.scrollOnInsertionAutorunnerDisposer = (0, mobx_1.autorun)(function () {
            var _a = _this.props, dropzonesStore = _a.dropzonesStore, projectScrollTo = _a.projectScrollTo;
            var currentDropzone = dropzonesStore.currentDropzone;
            var shouldScroll = _this.isOpen && currentDropzone.status === DropzonesStore_1.CurrentDropzoneState.Inserting;
            if (shouldScroll) {
                projectScrollTo(_this.innerRef.current, {
                    offset: 10,
                    time: 500,
                    scrollingElement: ".content-container__scroll-container",
                });
            }
        });
    };
    SavedBlockDropzoneOuter.prototype.componentWillUnmount = function () {
        this.activeAutorunnerDisposer();
        this.scrollOnInsertionAutorunnerDisposer();
        this.scrollOnPersistentDropzoneOpenAutorunnerDisposer();
        this.innerRectObserver.unobserve();
    };
    SavedBlockDropzoneOuter.prototype.render = function () {
        var _this = this;
        var dropzonesStore = this.props.dropzonesStore;
        var status = dropzonesStore.currentDropzone.status;
        var isOpen = this.isOpen;
        var isInserting = isOpen && status === DropzonesStore_1.CurrentDropzoneState.Inserting;
        var onDragOver = function (event) {
            var _a = _this.props, dragStore = _a.dragStore, dropzonesStore = _a.dropzonesStore;
            if (dragStore.dragItemIfCurrent(DragStore_1.DragType.SavedBlock)) {
                dropzonesStore.setCurrentDropzone(dropzonesStore.currentDropzone.index, DropzonesStore_1.CurrentDropzoneState.Active);
                event.preventDefault();
            }
        };
        return (react_1.default.createElement(SavedBlockDropzone_1.SavedBlockDropzoneInner, { isActive: this.isActive, isInserting: isInserting, isOpen: isOpen, onDragOver: onDragOver, ref: this.innerRef, configuration: SavedBlockDropzone_1.SavedBlockDropzoneConfiguration.InsideBlock }));
    };
    Object.defineProperty(SavedBlockDropzoneOuter.prototype, "isOpen", {
        get: function () {
            var _a = this.props, blockStore = _a.blockStore, blockList = _a.blockList, position = _a.position, dropzonesStore = _a.dropzonesStore;
            var blockIndex = blockList.getIndex(blockStore);
            var dropzoneIndex = blockIndex + (position === DropzonePosition.Top ? 0 : 1);
            var index = dropzonesStore.currentDropzone.index;
            var isOpen = dropzoneIndex === index;
            return isOpen;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SavedBlockDropzoneOuter.prototype, "isActive", {
        get: function () {
            var dropzonesStore = this.props.dropzonesStore;
            var status = dropzonesStore.currentDropzone.status;
            return this.isOpen && status === DropzonesStore_1.CurrentDropzoneState.Active;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SavedBlockDropzoneOuter.prototype, "isOpen", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SavedBlockDropzoneOuter.prototype, "isActive", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockDropzoneOuter.prototype, "updateViewportStatus", void 0);
    SavedBlockDropzoneOuter = __decorate([
        mobx_react_1.observer
    ], SavedBlockDropzoneOuter);
    return SavedBlockDropzoneOuter;
}(react_1.default.Component));
var mountSavedBlockDropzone = function (mountReactComponent) { return function (props) {
    return mountReactComponent(react_1.default.createElement(SavedBlockDropzoneOuter, __assign({}, props)));
}; };
exports.mountSavedBlockDropzone = mountSavedBlockDropzone;
